import * as signalR from "@microsoft/signalr";
import { store, expeditions } from "@/store";
import { env } from "@/env";
import { IExpedition, IExpeditionNotification, NotificationType, ISlot } from "@/models";
import { ToastHelper } from "../../helpers/ToastHelper";

const hubUrl = `${env.api.origin}${env.api.hubPath}/expeditions`;
const expeditionsHub = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, { accessTokenFactory: () => store.dispatch("user/getAccessToken") })
    .build();

expeditionsHub.on("ExpeditionUpdated", (expedition: IExpedition) => {
    store.commit("expeditions/EDIT_EXPEDITION", expedition); // change status on dashboard

    const expeditionNotification: IExpeditionNotification = {
        askAppointment: null,
        expedition,
        type: NotificationType.Appointment,
        startTime: expedition.expectedArrival,
    };

    store.commit("expeditions/MANAGE_NOTIFICATION", expeditionNotification); // add or remove notification
});

expeditionsHub.on("ExpeditionCreated", (expedition: IExpedition) => {
    store.commit("expeditions/ADD_EXPEDITION", expedition); // add expedition on dashboard
});

expeditionsHub.on("RemoveExpeditionNotification", (askAppointmentId: number) => {
    store.commit("expeditions/REMOVE_NOTIFICATION", askAppointmentId);
});

expeditionsHub.on("ExpeditionDeleted", (expeditionId: number, dock: number) => {
    store.commit("expeditions/DELETE_EXPEDITION", { expeditionId, dock });
    if (store.state.user.permission.security || store.state.user.permission.expedition) {
        ToastHelper.expeditions.toastDeleted();
    }
});

expeditionsHub.on("ExpeditionFilled", (expedition: IExpedition) => {
    if (store.state.user.permission.security || store.state.user.permission.expedition) {
        ToastHelper.expeditions.toastFilled(expedition);
    }
});

expeditionsHub.on("ExpeditionSlotsUpdated", (startSlot: ISlot, endSlot: ISlot) => {
    store.commit("expeditions/SET_EXPEDITION_START_SLOT", startSlot);
    store.commit("expeditions/SET_EXPEDITION_END_SLOT", endSlot);
});

export { expeditionsHub };
